export const shouldRedirectToSuposLogin = (config = md.global.Config || {}) => {
  return config.IsSso === true && location.href.indexOf('localhost') === -1;
};

export const getSuposLoginUrl = (returnUrl = location.href) => {
  return `/login/#/login?redirect_uri=${encodeURIComponent(returnUrl)}`;
};
